export default __webpack_public_path__ + "static/media/citlogo_white.037dd1fc.svg";